// extracted by mini-css-extract-plugin
export var pseudoButton = "submitButton-module--pseudoButton--6f977";
export var svg = "submitButton-module--svg--3b22b";
export var wrapper = "submitButton-module--wrapper--d1ef5";